// @ts-nocheck
import {
  CREATE_FREELANCE_FAILURE,
  CREATE_FREELANCE_REQUEST,
  CREATE_FREELANCE_SUCCESS,
  DELETE_FREELANCE_FAILURE,
  DELETE_FREELANCE_REQUEST,
  DELETE_FREELANCE_SUCCESS,
  FETCH_ALL_FREELANCE_FAILURE,
  FETCH_ALL_FREELANCE_REQUEST,
  FETCH_ALL_FREELANCE_SUCCESS,
  UPDATE_FREELANCE_FAILURE,
  UPDATE_FREELANCE_REQUEST,
  UPDATE_FREELANCE_SUCCESS,
} from "../../constants/user/freelance";

const initialState = {
  freelancers: [],
  searchString: "",
  isLoading: false,
  totalPages: 0,
  currentPage: 1,
  updateLoading: false,
};

const freelanceReducer = (state = initialState, action) => {
  switch (action?.type) {
    case FETCH_ALL_FREELANCE_REQUEST:
      return {
        ...state,
        searchString: action?.payload?.search,
        isLoading: true,
      };

    case FETCH_ALL_FREELANCE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        freelancers: action?.payload?.data || [],
        currentPage: action?.payload?.meta?.currentPage,
        totalPages: action?.payload?.meta?.totalPages,
      };

    case FETCH_ALL_FREELANCE_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // case create freelance user
    case CREATE_FREELANCE_REQUEST:
      return {
        ...state,
        updateLoading: true,
      };
    case CREATE_FREELANCE_SUCCESS:
      return {
        ...state,
        updateLoading: false,
      };
    case CREATE_FREELANCE_FAILURE:
      return {
        ...state,
        updateLoading: false,
      };

    // case update freelance user
    case UPDATE_FREELANCE_REQUEST:
      return {
        ...state,
        updateLoading: true,
      };
    case UPDATE_FREELANCE_SUCCESS:
      return {
        ...state,
        updateLoading: false,
      };
    case UPDATE_FREELANCE_FAILURE:
      return {
        ...state,
        updateLoading: false,
      };

    // case dleete freelance user
    case DELETE_FREELANCE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case DELETE_FREELANCE_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case DELETE_FREELANCE_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default freelanceReducer;
export { initialState };